import { PrecoProdutoClienteModel } from './../../model/produto/preco-produto-cliente';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable()
export class PrecoProdutoClienteService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(
    private httpCliente: HttpClient
  ) { }

  savePrecoProdutoCliente(preco: PrecoProdutoClienteModel): Observable<PrecoProdutoClienteModel> {
    return this.httpCliente.post<PrecoProdutoClienteModel> (this.apiURL + '/new/adicionar-preco-produto', preco, this.httpOptions);
  }

  listPrecos(id: any): Observable<any> {
    return this.httpCliente.get<any>(this.apiURL + '/view/precos-produto/' + id, this.httpOptions);
  }

  listPrecoCliente(idProduto: any, idCliente: any): Observable<any> {
    return this.httpCliente.get<any>(this.apiURL + '/view/precos/' + idProduto + '/' + idCliente, this.httpOptions);
  }

  editPrecoProdutoCliente(preco: PrecoProdutoClienteModel): Observable<PrecoProdutoClienteModel> {
    return this.httpCliente.put<PrecoProdutoClienteModel>(this.apiURL + '/edit/editar-preco-produto', preco, this.httpOptions);
  }

  deletePrecoProdutoCliente(idProduto: any, idCliente: any) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpCliente.get(this.apiURL + '/delete/apagar-preco-produto/' + idProduto + '/' + idCliente, { responseType: 'text', headers });
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/produto/preco-produto-cliente.service.ts